var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register-container payment" }, [
    _c("div", { staticClass: "text-center" }, [
      _vm.type === "success"
        ? _c("h1", [_vm._v("商品数が追加されました。")])
        : _c("h1", [_vm._v("決済処理が失敗しました。")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "announce-container" }, [
      _vm.type === "success"
        ? _c("div", [
            _c("span", [_vm._v("お支払いありがとうございます。")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "商品数が追加されました。現在の最大商品登録可能数: " +
                  _vm._s(_vm.maxListingAmount) +
                  "商品"
              )
            ]),
            _vm._v(" "),
            _c("br")
          ])
        : _c("div", [
            _c("span", [_vm._v("お支払い手続きありがとうございます。")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._m(1)
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("大変申し訳ございませんが、"),
      _c("br"),
      _c("h3", { staticClass: "text-red" }, [
        _vm._v("お支払いを確認することが出来ませんでした。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("ご利用できる支払い方法につきましては、"),
      _c("br"),
      _c(
        "a",
        {
          staticClass: "text--underline",
          attrs: {
            href:
              "https://support.stripe.com/questions/jp-which-cards-and-payment-types-can-i-accept-with-stripe",
            target: "_blank"
          }
        },
        [_vm._v("こちら")]
      ),
      _vm._v("をご参照ください")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b8e32be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8e32be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/PaymentSuccessOrFail.vue
// module id = null
// module chunks = 